export const validateLink = (link : string) => {
    return link?.startsWith('/') ? link?.slice(1) : link
}